import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { SearchBox } from 'fw/forms';
import { SponsorLevelCombo, TrueFalseFilter, StatusFilter } from 'areas/shared/controls'
import { SetupSearch } from 'areas/shared/pages/setup';
import * as API from 'modules/app/API';
import AddNewPopUp from './AddNewPopUp';
import * as App from 'modules/app/App';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

class Search extends SetupSearch {

    initialForm() {
		var params = queryString.parse(this.props.location.search);

		var initialSponsorLevelId = null;
		var initialSponsorLevelName = "";
		var initialStatusFilter = null;
		var initialStatusFilterName = "All members";
		var initialExpiredFilter = null;
		var initialExpiredFilterName = "All";

		// The three initial settings below are mutually exclusive because params come from dashboard links
		// (if in the future, params come from other sources, this code has to be modified accordingly)

		// If Membership Level param came from Dashboard, do not filter by Status or Expired
		if (params.membershipLevelId != null){
			initialSponsorLevelId = params.membershipLevelId;
			initialSponsorLevelName = params.membershipLevelName;
			initialStatusFilter = null;
			initialStatusFilterName = "All members";
			initialExpiredFilter = null;
			initialExpiredFilterName = "All";
		}

		// If Active param came from Dashboard, do not filter by Expired
		if (params.active != null){
			initialStatusFilter = params.active;
			initialStatusFilterName = params.active === "true" ? "Active members" : "Inactive members";
			initialExpiredFilter = null;
			initialExpiredFilterName = "All";
		}

		// If Expired param came from Dashboard, do not filter by Status
		if (params.expired != null){
			initialStatusFilter = null;
			initialStatusFilterName = "All members";
			initialExpiredFilter = params.expired;
			initialExpiredFilterName = params.expired === "true" ? "Expired" : "Current";
		}

        return {
            searchText: "",
            statusFilter: initialStatusFilter,
			initialStatusFilterName,
            expiredFilter: initialExpiredFilter,
			initialExpiredFilterName,
            sponsorLevelId: initialSponsorLevelId,
			initialSponsorLevelName,
            roleId: null,
            userTypeCode: null,
            addPrivilege: App.hasPrivilege("AdminSponsorSetupAdd")
        };
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    searchLoader = () => {
        return {
            url: API.Search.url('/suggest'),
            params: {
                type: 'sponsor'
            }
        }
    }

    onAddNewClose = (success) => {
        this.setState({
            showAddNewPopUp: false
        }, () => { if (success === true) { this.reload() } });
    }

    onAddNewClick = () => {
        this.setState({
            showAddNewPopUp: true
        });
    }

    renderForm() {
        return (
            <Row>
                <Col md={3}>
                    <SearchBox
                        name="searchText"
                        label="searchText"
                        placeholder="Search members..."
                        loader={this.searchLoader}
                        ref={(c) => { this.focusControl = c }} />
                </Col>
                <Col md={2}>
                    <SponsorLevelCombo clearable name='sponsorLevelId' 
						 label="initialSponsorLevelName" onChange={this.search} placeholder="Membership Level" />
                </Col>
                <Col md={2}>
                    <TrueFalseFilter name="expiredFilter" 
                        onChange={this.search}
                        trueLabel="Expired"
                        falseLabel="Current"
						label="initialExpiredFilterName"
                        placeholder="Status" />
                </Col>
                <Col md={2}>
                    <StatusFilter name="statusFilter" label="initialStatusFilterName" onChange={this.search} entity="members" />
                </Col>
                {this.state.form.addPrivilege ?
                    <Col md={3} style={{paddingRight:"5px"}}>
                        <Button style={{marginTop:"-55px"}} id='btnAddNewPopUp' onClick={this.onAddNewClick} bsClass="btn btn-success" className="pull-right">
                            Add new member
                        </Button>
                        <AddNewPopUp
                            style={{marginTop:"-55px"}}
                            visible={this.state.showAddNewPopUp}
                            onClose={this.onAddNewClose}
                            sponsorId={this.state.form.sponsorId}
                        />
                    </Col>
                :null }
            </Row>
        )
    }
}

export default withRouter(Search);



// WEBPACK FOOTER //
// ./src/areas/admin/sponsorSetup/Search.js